// Paste your Firebase web config here.
// Safe to commit: these values are public identifiers, not secrets.
// Security comes from Firebase Authorized Domains + (later) backend ID token verification.
export const firebaseConfig = {
  apiKey: "AIzaSyB4uVxmvdPF3yCENqCsCLSuld5TkxuQ0z0",
  authDomain: "gym-tracker-219c8.firebaseapp.com",
  projectId: "gym-tracker-219c8",
  storageBucket: "gym-tracker-219c8.firebasestorage.app",
  messagingSenderId: "461224307756",
  appId: "1:461224307756:web:0af6ae2003852038037589",
  measurementId: "G-4X4MTDHPMZ"
};
